
/**
 * 题库
 */

 export const QuestionBankDataList=[
    {
        prop: "id",
        label: "id",
        width: "150",
        format: "",
        order: false,
        isShow: false,
      },
    {
      prop: "name",
      label: "题库名称",
      width: "150",
      format: "",
      order: false,
      isShow: true,
    },
    {
      prop: "description",
      label: "描述",
      width: "300",
      format: "",
      order: false,
      isShow: true,
    },
    {
      prop: "categoryName",
      label: "分类",
      width: "250",
      format: "",
      order: false,
      isShow: true,
    },
    {
      prop: "number",
      label: "题目数量",
      width: "150",
      format: "",
      order: false,
      isShow: true,
    },
  ];

  export const CategoryDataList=[
    {
        key:0,
        value:"平台"
    },
    {
        key:1,
        value:"公司"
    }
  ]

